(function () {
	'use strict';

	var modal = null;
	var triggerInput = null;
	var triggerButton = null;
	var triggerForm = null;
	var lastTrigger = null;

	document.addEventListener( 'DOMContentLoaded', function () {
		modal = document.getElementById( 'gardp-newsletter-modal' );
		if ( ! modal ) {
			return;
		}

		triggerInput = document.getElementById( 'gardp-nl-email' );
		triggerButton = document.querySelector( '[data-newsletter-open]' );
		triggerForm = document.querySelector( '.gardp-footer-form' );

		if ( triggerInput ) {
			triggerInput.addEventListener( 'input', function () {
				if ( isModalOpen() ) {
					syncEmailToMailchimpField( triggerInput.value );
				}
			} );
		}

		if ( triggerForm ) {
			triggerForm.addEventListener( 'submit', function ( event ) {
				event.preventDefault();
				openModal( triggerInput || triggerButton || triggerForm );
			} );
		}

		if ( triggerButton ) {
			triggerButton.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				openModal( triggerButton );
			} );
		}

		modal.addEventListener( 'click', function ( event ) {
			if ( event.target === modal || event.target.closest( '[data-newsletter-close]' ) ) {
				closeModal();
			}
		} );

		document.addEventListener( 'keydown', function ( event ) {
			if ( event.key === 'Escape' && isModalOpen() ) {
				event.preventDefault();
				closeModal();
			}
		} );
	} );

	function openModal( source ) {
		if ( ! modal ) {
			return;
		}

		lastTrigger = source || null;
		modal.hidden = false;
		modal.setAttribute( 'aria-hidden', 'false' );
		document.body.classList.add( 'gardp-newsletter-modal-open' );
		syncEmailToMailchimpField( triggerInput ? triggerInput.value : '' );

		var targetField = modal.querySelector( 'input[type="email"]' );
		if ( targetField ) {
			window.setTimeout( function () {
				targetField.focus();
			}, 10 );
		}
	}

	function closeModal() {
		if ( ! modal ) {
			return;
		}

		modal.hidden = true;
		modal.setAttribute( 'aria-hidden', 'true' );
		document.body.classList.remove( 'gardp-newsletter-modal-open' );

		if ( lastTrigger && typeof lastTrigger.focus === 'function' ) {
			lastTrigger.focus();
		}
	}

	function isModalOpen() {
		return modal && ! modal.hidden;
	}

	function syncEmailToMailchimpField( emailValue ) {
		if ( ! modal || ! emailValue ) {
			return;
		}

		var mcField = modal.querySelector( 'input[type="email"]' );
		if ( mcField && ! mcField.value ) {
			mcField.value = emailValue;
		}
	}
})();
